import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
/* reducer */
import * as fromDoctorDataStore from './state/doctor-data-store.reducer';

/* effects */
import { DoctorDataStoreEffects } from './state/doctor-data-store.effects';

@NgModule({
  declarations: [],
  imports: [
    CommonModule,

    /* DoctorDataStore State */
    StoreModule.forFeature(
      fromDoctorDataStore.featureKey,
      fromDoctorDataStore.reducer,
      { initialState: fromDoctorDataStore.initialState },
    ),
    EffectsModule.forFeature([DoctorDataStoreEffects]),
  ],
  exports: [StoreModule, EffectsModule],
})
export class DoctorDataStoreModule {}
